import { render, staticRenderFns } from "./HistoryRequestStatusLog.vue?vue&type=template&id=f31a1854"
import script from "./HistoryRequestStatusLog.vue?vue&type=script&lang=js"
export * from "./HistoryRequestStatusLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports